import React from 'react';
import { PageLayout } from '../../components/PageLayout';
import { HeaderBanner } from './HeaderBanner';
import { KeyHighlights } from './KeyHighlights';
import { CourseDescription } from './CourseDescription';
import { RegistrationCallout } from './RegistrationCallout';
import { ClassProcedures } from './ClassProcedures';
import { QuickLinks } from './QuickLinks';
export function FirstStepsPistolPage() {
  return <PageLayout data-id="element-1519">
      <HeaderBanner data-id="element-1520" />
      <KeyHighlights data-id="element-1521" />
      <CourseDescription data-id="element-1522" />
      <RegistrationCallout data-id="element-1523" />
      <ClassProcedures data-id="element-1524" />
      <QuickLinks data-id="element-1525" />
    </PageLayout>;
}